import userFormModel from './userFormModel';

const {
  formField: {
    fullName,
    email,
    emailContact,
    registration,
    cpf,
    phone1,
    phone2,
    area,
    subArea,
    office,
    manager,
    specialNeed,

    zipCode,
    street,
    number,
    complement,
    district,
    city,
    state,

    profiles,
    groups,
  },
} = userFormModel;

export default {
  [fullName.name]: '',
  [email.name]: '',
  [emailContact.name]: '',
  [registration.name]: '',
  [cpf.name]: '',
  [phone1.name]: '',
  [phone2.name]: '',
  [area.name]: '',
  [subArea.name]: '',
  [office.name]: '',
  [manager.name]: '',
  [specialNeed.name]: '',

  [zipCode.name]: '',
  [street.name]: '',
  [number.name]: '',
  [complement.name]: '',
  [district.name]: '',
  [city.name]: '',
  [state.name]: '',

  [profiles.name]: [],
  [groups.name]: [],
};
